import React, { useEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import LoadingScreen from 'components/LoadingScreen';
import { lookupReferralLink, registerReferralVisit } from 'api/referralLinks';
import {
  captureReferralContext,
  confirmReferralContext,
  clearReferralContext,
} from 'utils/referralContext';
import referralDestination from 'utils/referralDestination';

/** ReferralLinkEntry component. Resolve a shortlink before mounting its destination. */
export default function ReferralLinkEntry() {
  const { slug } = useParams();
  const { search } = useLocation();
  const history = useHistory();

  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    const context = captureReferralContext(slug);
    registerReferralVisit(slug, context.visitId);
    lookupReferralLink(slug, controller.signal)
      .then((link) => {
        if (!active) return;
        confirmReferralContext(context, link.discount_code);
        const target = referralDestination(link.destination_path, slug, search);
        history.replace(target);
      })
      .catch((error) => {
        if (!active) return;
        if (error.code === 404) clearReferralContext(context);
        history.replace('/');
      });
    return () => {
      active = false;
      controller.abort();
    };
  }, [slug, search, history]);

  return <LoadingScreen hasHeader={false} />;
}
